/*========================================================================
* $Id: browser.js 83487 2015-03-17 11:11:36Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([], function() {

return {
      /**
      * $.csv.fromArrays(arrays)
      * Converts a javascript array to a CSV String.
      *
      * @param {Array} arrays An array containing an array of CSV entries.
      * @param {Object} [options] An object containing user-defined options.
      * @param {Character} [separator] An override for the separator character. Defaults to a comma(,).
      * @param {Character} [delimiter] An override for the delimiter character. Defaults to a double-quote(").
      *
      * This method generates a CSV file from an array of arrays (representing entries).
      */
      csvFromArrays: function(arrays, options, callback) {
        var options = (options !== undefined ? options : {});
        var config = {};
        config.callback = ((callback !== undefined && typeof(callback) === 'function') ? callback : false);
        config.separator = 'separator' in options ? options.separator :";";
        config.delimiter = 'delimiter' in options ? options.delimiter : '"';

        var output = '',
        line,
        lineValues,
        i, j;

        for (i = 0; i < arrays.length; i++) {
          line = arrays[i];
          lineValues = [];
          for (j = 0; j < line.length; j++) {
            var strValue = (line[j] === undefined || line[j] === null)
            ? ''
            : line[j].toString();
            if (strValue.indexOf(config.delimiter) > -1) {
              strValue = strValue.replace(config.delimiter, config.delimiter + config.delimiter);
            }

            var escMatcher = '\n|\r|S|D';
            escMatcher = escMatcher.replace('S', config.separator);
            escMatcher = escMatcher.replace('D', config.delimiter);

            if (strValue.search(escMatcher) > -1) {
              strValue = config.delimiter + strValue + config.delimiter;
            }
            lineValues.push(strValue);
          }
          output += lineValues.join(config.separator) + '\r\n';
        }

        // push the value to a callback if one is defined
        if(!config.callback) {
          return output;
          } else {
          config.callback('', output);
        }
      },


      // This will parse a delimited string into an array of
      // arrays. The default delimiter is the comma, but this
      // can be overriden in the second argument.
      CSVToArray: function ( strData, strDelimiter ){
        // Check to see if the delimiter is defined. If not,
        // then default to comma.
        strDelimiter = (strDelimiter || ",");

        // Create a regular expression to parse the CSV values.
        var objPattern = new RegExp(
        (
        // Delimiters.
        "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

        // Quoted fields.
        "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

        // Standard fields.
        "([^\"\\" + strDelimiter + "\\r\\n]*))"
        ),
        "gi"
        );


        // Create an array to hold our data. Give the array
        // a default empty first row.
        var arrData = [[]];

        // Create an array to hold our individual pattern
        // matching groups.
        var arrMatches = null;


        // Keep looping over the regular expression matches
        // until we can no longer find a match.
        while (arrMatches = objPattern.exec( strData )){

          // Get the delimiter that was found.
          var strMatchedDelimiter = arrMatches[ 1 ];

          // Check to see if the given delimiter has a length
          // (is not the start of string) and if it matches
          // field delimiter. If id does not, then we know
          // that this delimiter is a row delimiter.
          if (
          strMatchedDelimiter.length &&
          (strMatchedDelimiter != strDelimiter)
          ){

            // Since we have reached a new row of data,
            // add an empty row to our data array.
            arrData.push( [] );

          }


          // Now that we have our delimiter out of the way,
          // let's check to see which kind of value we
          // captured (quoted or unquoted).
          if (arrMatches[ 2 ]){

            // We found a quoted value. When we capture
            // this value, unescape any double quotes.
            var strMatchedValue = arrMatches[ 2 ].replace(
            new RegExp( "\"\"", "g" ),
            "\""
            );

            } else {

            // We found a non-quoted value.
            var strMatchedValue = arrMatches[ 3 ];

          }


          // Now that we have our value string, let's add
          // it to the data array.
          arrData[ arrData.length - 1 ].push( strMatchedValue );
        }

        // Return the parsed data.
        return( arrData );
      }
   };
});
